import { IconsProps } from '@/types/shared'
import React from 'react'

const AgeIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-person-standing-icon lucide-person-standing"
            >
                <circle cx="12" cy="5" r="1" />
                <path d="m9 20 3-6 3 6" />
                <path d="m6 8 6 2 6-2" />
                <path d="M12 10v4" />
            </svg>
        </div>
    )
}

export default AgeIcons
